/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} StyleInputs */

const en_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const es_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo`)
};

const fr_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Style`)
};

const de_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stil`)
};

const ja_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スタイル`)
};

const zh_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`风格`)
};

const ar_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النمط`)
};

const id_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gaya`)
};

const it_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stile`)
};

const ru_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Стиль`)
};

const pt_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Estilo`)
};

const ko_style = /** @type {(inputs: StyleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스타일`)
};

/**
* | output |
* | --- |
* | "Style" |
*
* @param {StyleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const style = /** @type {((inputs?: StyleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<StyleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_style(inputs)
	if (locale === "es") return es_style(inputs)
	if (locale === "fr") return fr_style(inputs)
	if (locale === "de") return de_style(inputs)
	if (locale === "ja") return ja_style(inputs)
	if (locale === "zh") return zh_style(inputs)
	if (locale === "ar") return ar_style(inputs)
	if (locale === "id") return id_style(inputs)
	if (locale === "it") return it_style(inputs)
	if (locale === "ru") return ru_style(inputs)
	if (locale === "pt") return pt_style(inputs)
	return ko_style(inputs)
});